import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AlertState {
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
  displayAlert: boolean;
}

const initialState: AlertState = {
  message: '',
  severity: 'info',
  displayAlert: false,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (
      state,
      action: PayloadAction<{ message: string; severity: 'success' | 'info' | 'warning' | 'error' }>,
    ) => {
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.displayAlert = true;
    },
    hideAlert: (state) => {
      state.displayAlert = false;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;
